module.exports = __webpack_public_path__ + "img/googleplay.c5ea6c0d.webp";